import React from 'react';
import classnames from 'classnames';

import type { IBaseProps } from '@home/types/common';

import './index.scss';

interface IReportNoDataProps extends IBaseProps {
  hasPermission?: boolean;
  onAdd?: () => void;
}

const ReportNoData: React.FC<IReportNoDataProps> = (props) => {
  const { style, className, hasPermission = false, onAdd } = props;

  return (
    <div style={style} className={classnames('dbg-dps-report-nodata', className)}>
      <span>No data</span>
      {hasPermission && (
        <span>
          .You can click{' '}
          <a
            className="dbg-dps-report-nodata__link-btn"
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              onAdd?.();
            }}
          >
            Add new Newsletter
          </a>
        </span>
      )}
    </div>
  );
};

export default ReportNoData;
